import styled from 'styled-components';

export const ZoomLabel = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  padding: 0 ${({ theme }) => theme.spacing(0.5)};
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.primary};
  user-select: none;
`;
